import { MSG, RequestPasswordResetRequest } from "@genbaryoku/contract";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation } from "react-router";
import { api, ApiError, messageOf } from "../api.js";
import { AuthCard, BackToLogin, ErrorText, Field, guardComposingEnter, useFieldIds } from "../components/ui.jsx";

export function ForgotPage() {
  const ids = useFieldIds(["mail"] as const);
  const [sent, setSent] = useState<string | null>(null);
  const [serverError, setServerError] = useState<string | undefined>();
  const [notFound, setNotFound] = useState(false);
  // ログインのロックの文から来たとき（#111）はメールアドレスを入れておく
  const fromLogin = (useLocation().state as { email?: string } | null)?.email ?? "";
  const form = useForm<RequestPasswordResetRequest>({ resolver: zodResolver(RequestPasswordResetRequest), defaultValues: { email: fromLogin }, shouldFocusError: true });

  const submit = form.handleSubmit(async (v) => {
    setServerError(undefined);
    setNotFound(false);
    try {
      await api("POST", "/auth/request-password-reset", v);
      setSent(v.email);
    } catch (e) {
      if (e instanceof ApiError && e.code === "AUTH_USER_NOT_FOUND") setNotFound(true);
      setServerError(messageOf(e));
    }
  });

  if (sent) {
    return (
      <AuthCard notices title={MSG.forgotSentTitle}>
        <p>
          <b className="num" style={{ fontSize: "var(--fs-19)" }}>{sent}</b>{MSG.forgotSentBody}
        </p>
        <p className="hint">{MSG.forgotSentNote}</p>
        <div className="authlinks">
          <BackToLogin />
        </div>
      </AuthCard>
    );
  }

  // #287（2026-11-01 射場さん ★4、docs/100）：題は「パスワード再設定」、「？」をやめて本文に1行（PC版・スマホ版で同じ）
  return (
    <AuthCard notices title={MSG.forgotTitle} onSubmit={submit}>
      <p className="authlead" data-testid="forgot-lead">{MSG.forgotLead}</p>
      <Field id={ids.mail} label="メールアドレス">
        <input id={ids.mail} className="inp" type="email" inputMode="email" autoComplete="username" onKeyDown={guardComposingEnter} {...form.register("email")} />
      </Field>
      <ErrorText>{serverError ?? form.formState.errors.email?.message}</ErrorText>
      {notFound ? (
        <p className="hint">
          <Link className="btn text" to="/signup">会員登録</Link>
        </p>
      ) : null}
      <button type="submit" className="btn primary big" disabled={form.formState.isSubmitting}>
        {MSG.forgotSubmit}
      </button>
      <div className="authlinks">
        <BackToLogin />
      </div>
    </AuthCard>
  );
}

